import { render } from "./ctaBlockModal.vue?vue&type=template&id=50316c1d&ts=true"
import script from "./ctaBlockModal.vue?vue&type=script&lang=ts"
export * from "./ctaBlockModal.vue?vue&type=script&lang=ts"

import "./ctaBlockModal.vue?vue&type=style&index=0&id=50316c1d&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__